import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "@vilocnv/allsetra-core";
import i18n from "i18next";
import { putKeyInventory } from "domain/keys/api/put-key-inventory";
import { KeyActionRequestDto } from "domain/keys/entities/dtos/key-action-request.dto";

const putKeyInventoryAction = createAsyncThunk(
  "keys/putKeyInventoryAction",
  async (request: KeyActionRequestDto, thunkAPI) => {
    try {
      return await putKeyInventory(request);
    } catch (error: any) {
      console.error(error);
      toast.error(i18n.t("toasts.putKeyInventoryError"));
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export default putKeyInventoryAction;
